import {
  SERIES_CRUMB,
  SUBJECT_DETAIL_CRUMB,
} from "../constants/BreadcrumConstants";
export const breadCrumbHelper = (data, query) => {
  if (!data?.series_name) {
    const parent = {
      path: `${subjectUri(query.get("subject_slug"))}`,
      title: `${data?.subject_name}`,
    };
    return data?.parent_subject_name
      ? [
          SUBJECT_DETAIL_CRUMB,
          {
            path: `${subjectUri(data?.parent_subject_slug)}`,
            title: `${data?.parent_subject_name}`,
          },
          parent,
        ]
      : [SUBJECT_DETAIL_CRUMB, parent];
  } else {
    return [
      SERIES_CRUMB,
      {
        path: `${subjectUri(data?.subject_slug)}`,
        title: `${data?.subject_name}`,
      },
    ];
  }
};
const subjectUri = (subject_slug) => {
  return `/subjectlanding?subject_slug=${subject_slug}`;
};
